import 'swiper/components/navigation/navigation.scss';

import { GatsbyImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { BREAKPOINTS } from '../../../constants/breakpoints';

SwiperCore.use([Autoplay, Pagination, Navigation]);

const Carousel = ({ data }) => {
  return (
    <Swiper
      autoplay={{
        delay: 3000,
        stopOnLastSlide: false,
        waitForTransition: false,
      }}
      breakpoints={{
        [BREAKPOINTS.desktopXS]: {
          slidesPerView: 4.5,
        },
        [BREAKPOINTS.desktopMD]: {
          slidesPerView: 5.5,
        },
      }}
      loop
      slidesPerView={2.5}
      spaceBetween={20}
    >
      {Object.values(data).map((profile) => {
        return (
          <SwiperSlide>
            <div className="partnerships-quickbooks-mailchimp__border-image">
              <GatsbyImage alt={profile.name} image={profile.image} />
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

Carousel.propTypes = {
  data: PropTypes.object,
};

export default Carousel;
